
















































import { mapState, mapGetters } from 'vuex'
import FilterRow from "./FilterRow.vue";

export default {
  name: "FilteredList",
  components: {
    FilterRow
  },
  data() {
    return {
      activeIndex: 0,
      sortParameters: ['tower','pentNumber','area', 'view', 'priceForMeter', 'priceFull']
    }
  },
  computed: {
    ...mapState(['penthousesList', 'sortFromSmall', 'windowWidth']),
    ...mapGetters(['penthousesFilteredAndSorted']),
    isSmall() {
      return this.windowWidth < 1200
    }
  },
  methods: {
    toggleSortArrow(index) {
      if (this.activeIndex === index) {
        this.$refs[`column-${this.activeIndex}`].classList.toggle('reverse');
        this.$refs[`column-${this.activeIndex}`].classList.add('active');
        this.$store.dispatch('updateSort', {param:this.sortParameters[index], sortFromSmall: !this.sortFromSmall});
        return
      }
      this.$refs[`column-${this.activeIndex}`].classList.remove('reverse');
      this.$refs[`column-${this.activeIndex}`].classList.remove('active');
      this.activeIndex = index;
      this.$store.dispatch('updateSort', {param:this.sortParameters[index], sortFromSmall: true});
      this.$refs[`column-${this.activeIndex}`].classList.add('reverse');
      this.$refs[`column-${this.activeIndex}`].classList.add('active');
    }
  }
}
